import ChatService from "../services/chat.service";

export const askQuestion = (data) => (dispatch) => {
  return ChatService.askQuestion(data);
};

export const chatHistory = (id) => (dispatch) => {
  return ChatService.chatHistory(id);
};

export const askUserQuestion = (data) => (dispatch) => {
  return ChatService.askUserQuestion(data);
};

export const userChatHistory = (documentIds) => (dispatch) => {
  return ChatService.userChatHistory(documentIds);
};
